export default __webpack_public_path__ + "static/media/DharmaGothicE_Regular_R.ddcca876.otf";